import { combineReducers } from 'redux';
import employeeTypeReducer from './employeeReducers';
import provinceTypeReducer from './provinceReducers';
import viewManagerReducer from './viewManagerReducer';
import  viewConciergeReducer from './viewConciergeReducer';
import empReducer from './empReducer';
import siteReducer from './siteReducer';
import visitorTypesReducer from './visitorTypeReducer';
import visitorReducer from './visitorReducer';
import dashboardReducer from './dashboardReducer';

const rootReducer = combineReducers({
   
    employeeType: employeeTypeReducer,
    provinceType: provinceTypeReducer,
    viewManager: viewManagerReducer,
    viewConcierge:  viewConciergeReducer,
    employee: empReducer,
    site: siteReducer,
    visitorType: visitorTypesReducer,
    visitor: visitorReducer,
    dashboard: dashboardReducer,
  
});

export default rootReducer;